<template>
    <Teleport to="body">
        <ModalFrame v-for="entry in stack" :key="entry.id" :entry="entry" />
    </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ModalService from '@/services/modal'
import ModalFrame from './ModalFrame.vue'

const stack = computed(() => ModalService.stack)
</script>
